import {createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { calculate_differences } from './transforms/calculations';
import axios from "axios";
import { apply, compose as C, concat, countBy, find, forEach,fromPairs, gt, head, identity, 
    ifElse, isNil, join, juxt, keys, last, length, lt, map as m, max, nth, objOf, of, pair,
    path, prop as p, propEq, reduce, reject, split, toPairs, unless, values, __,
    flatten,
    groupBy as g, 
} from 'ramda';
import { initial } from './initial';

const fetch_data = file => new Promise((resolve) => axios.get(file).then(resolve));
const set = key => (state,{payload}) => {state[key] = payload}

export const slice = createSlice({
    name: "main",
    initialState: initial,
    reducers: {
        loadState: (state, {payload}) => 
            ({...state,...payload,comparison: payload.comparison || keys(payload.countries)}),
        toggle_panel: (state,{payload}) => {state.panel_open = payload === undefined ? !state.panel_open : payload},
        toggle_legend: (state,{payload}) => {state.legend_open = payload === undefined ? !state.legend_open : payload},
        toggle_expanded: (state,{payload}) => {state.expanded = payload === undefined ? !state.expanded : payload},
        cache_data: (state,{payload:[wave,data]}) => {state.waves = {...state.waves, [wave] : data}},
        selectCountry: set("country"),
        selectComparison: set("comparison"),
        setDifferences: set("differences"),
        setIndicator: set("bubble"),
        setSubindicator: set("select"),
        setActiveLabels: set("active_labels"),
        setItem: set("item"),
        setPane: set("pane"),
        runTour: set("run_tour"),
        setEustNr: set("eust_nr"),
        setUrl: set("url"),
        setTutorial: set("tutorial"),
    }});

export const {setIndicator,setSubindicator,setItem,selectCountry,cache_data,toggle_expanded,
    selectComparison,setDifferences: calcDiffs,loadState,setEustNr,toggle_legend,runTour,
    toggle_panel,setActiveLabels,setPane,setTutorial,setUrl} = slice.actions; 
    
const set_url = (val) => (dispatch,getState) => {
    const {url} = getState();
    dispatch(setUrl({...url,...val}))
    const params = C(concat("?"),join("&"),m(join("=")),toPairs,reject(isNil))({...url,...val})
    window.history.replaceState(null,null,params); 
}
export function recalc_data(selected) {
    return (dispatch,getState) => {
        const {country,data,conf,fns,response_rates} = getState();
        dispatch(selectComparison(selected));
        dispatch(calcDiffs(calculate_differences(selected,country,data,conf,fns,response_rates)))
        dispatch(set_url({"comparison": selected || null}));};
}
export function update_country(new_country) {return (dispatch,getState) => {
    const {comparison,data,conf,fns,response_rates} = getState();
    dispatch(selectCountry(new_country));
    dispatch(calcDiffs(calculate_differences(comparison,new_country,data,conf,fns,response_rates)));
    dispatch(set_url({"country": new_country}));};
}
export function temp_country(new_country) {return (dispatch,getState) => {
    const {comparison,data,conf,fns,response_rates} = getState();
    dispatch(selectCountry(new_country));
    dispatch(calcDiffs(calculate_differences(comparison,new_country,data,conf,fns,response_rates)));
}}
const multi = (conf,bubble) => C(gt(__,1),length,p("children"),find(propEq("id",bubble)))(conf);

export const setLabels = (item) => (dispatch,getState) => {
    const state = getState();
    const id = item ? item : state.bubble;
    const nth_item = C(
        ifElse(isNil,() => head,C(
            ifElse(C(lt(__,2),length),() => head,C(nth,nth(1))),
            split(","))),
            p("visual_data"),
            p(__,state.fns),
            p("fn"),
            find(propEq("id",id)),
            p("conf"))(state)  
            const active_labels = C(
                unless(isNil,ifElse(C(lt(__,2),reduce(max,0),values,countBy(identity),last),last,head)),
                path(["item_labels",Number(id)]))(state);
                dispatch(setActiveLabels(active_labels));
                dispatch(setItem(!active_labels || multi(state.conf,Number(id)) ? null : nth_item(active_labels)));
            }
export const selectSubindicator = ({select,select2,item}) => (dispatch) => {
    console.log(select,select2,item);
    dispatch(setSubindicator(select));
    if(select2) {setTimeout(() => {dispatch(setSubindicator(select2 || {active:null}));},300);}
    dispatch(setLabels(item));
    dispatch(set_url({"subindicator": item || null}));
}

export const toggleTutorial = (val) => (dispatch) => {
    window.sessionStorage.setItem('tutorial', val);
    dispatch(setTutorial(!!val));
}
export const selectIndicator = id => (dispatch,getState) => {
    const state = getState();
    const conf = find(propEq("id",id),state.conf)
    const multiple = multi(state.conf,id);
    dispatch(toggle_panel());
    dispatch(setIndicator(id));
    dispatch(setSubindicator({active:multiple ? null : conf.Name}));
    if (multiple) dispatch(setPane(0));
    dispatch(setLabels());
    dispatch(set_url({indicator:id, subindicator:null}));
}
export const temp_indicator = id => (dispatch,getState) => {
    const state = getState();
    const conf = find(propEq("id",id),state.conf)
    const multiple = multi(state.conf,id);
    dispatch(setIndicator(id));
    dispatch(setSubindicator({active:multiple ? null : conf.Name}));
    if (multiple) dispatch(setPane(0));
    dispatch(setLabels());
}


export const changeEustNr = createAsyncThunk("change_wave",async (eust_nr,{dispatch,getState}) => {
    const {waves:before} = getState()
    dispatch(setEustNr(eust_nr));
    if (!before[eust_nr]) {
        const response = await fetch_data(`eust${eust_nr}.json`);
        dispatch(cache_data([eust_nr,response.data]));
    }
    const {waves:after,country:c,comparison:cs,select,bubble} = getState();
    console.log(C(g(p("Name")),flatten,m(p("conf")),values)(after));
    const the_country = !!after[eust_nr].samples[c] ? c : undefined;
    const the_bubble = !!after[eust_nr].conf[bubble] ? bubble : '12';
    const the_select = !!after[eust_nr].conf[bubble] ? select : {active:'Age'};
    const the_comparison = cs.filter(x => Object.keys(after[eust_nr].samples).includes(x))
    dispatch(set_url({
        "eust_nr": eust_nr, 
        "country":the_country,
        "comparison":the_comparison,
        ...(the_bubble === '12' ? {indicator: '12', subindicator:null} : {})
    }));
    dispatch(loadState({...after[eust_nr],
        ...{country: the_country},
        ...{bubble:the_bubble},
        ...{select:the_select},
        ...{comparison:the_comparison}
    }));
    const {comparison,country,data,conf,fns,response_rates} = getState();
    dispatch(calcDiffs(calculate_differences(comparison,country,data,conf,fns,response_rates)));
    dispatch(setSubindicator(the_select));
});


export const initialize_state = createAsyncThunk("load_data",async (_,{dispatch,getState}) => {
    const url = new URLSearchParams(window.location.search.slice(1))
    const load_and_set = ([x,fn,prep]) => {
        const val = url.get(x);
        if(val) {
            dispatch(apply(fn,prep(val)))
            const {url:obj} = getState();
            dispatch(setUrl({...obj,[x]:val}))
        }
    }

    load_and_set(["eust_nr",setEustNr,C(of,Number)]);
    const {eust_nr, waves:before} = getState()
    if (!before[eust_nr]) {
        const response = await fetch_data(`eust${eust_nr}.json`);
        dispatch(cache_data([eust_nr,response.data]));
    } 
    const {waves:after} = getState();
    dispatch(loadState(after[eust_nr]));

    const {conf} = getState();
    const sub_fn = C(of,fromPairs,juxt([
        C(pair("select"),objOf("active"),p("Name"),x => find(propEq("id",x),conf)),
        pair("item")]));
    forEach(load_and_set,[
        ["comparison",selectComparison,C(of,split(","))],
        ["country",selectCountry,of],
        ["indicator",selectIndicator,of],
        ["subindicator",selectSubindicator,sub_fn]]);

    const {comparison,country,data,fns,response_rates} = getState();
    dispatch(calcDiffs(calculate_differences(comparison,country,data,conf,fns,response_rates)));
});